import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=df15cce4&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.css?vue&type=style&index=0&id=df15cce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df15cce4",
  null
  
)

export default component.exports